<template>
    <div>
        <ul v-if="total_size > page_size && pager.page_array && pager.page_array.length > 1" class="n2-pager n2-clear">
            <li>
                <a v-on:click.prevent="navToPage(1)" v-bind:class="{ disabled: pager.current_page_number === 1 }" href="#">&lt;&lt;</a>
            </li>
            <li>
                <a v-on:click.prevent="navToPage(pager.current_page_number - 1)" v-bind:class="{ disabled: pager.current_page_number === 1 }" href="#">&lt;</a>
            </li>
            <li v-for="page in pager.page_array" v-bind:key="page">
                <a v-on:click.prevent="navToPage(page)" v-bind:class="{active:pager.current_page_number == page}" href="#">{{page}}</a>
            </li>
            <li>
                <a v-on:click.prevent="navToPage(pager.current_page_number + 1)" v-bind:class="{disabled:pager.current_page_number === pager.total_page_count}" href="#">&gt;</a>
            </li>
            <li>
                <a v-on:click.prevent="navToPage(pager.total_page_count)" v-bind:class="{disabled:pager.current_page_number === pager.total_page_count}" href="#">&gt;&gt;</a>
            </li>
        </ul>
    </div>
</template>
<script>export default {
        name: 'pager',
        props: ['page_number', 'page_size', 'total_size'],
        data: function () {
            return {
            };
        },
        computed: {
            pager: function () {
                return this.getPager(+this.total_size, +this.page_number, +this.page_size);
            }
        },
        methods: {
            navToPage: function (page_number) {
                if (+page_number < 1 || +page_number > this.pager.total_page_count) {
                    return;
                }
                this.$emit('page-changed', page_number);
            },
            getPager: function (total_size, current_page_number = 1, page_size = 10) {
                if (!current_page_number) {
                    current_page_number = 1;
                }
                if (total_size) {
                    if (total_size < 0) {
                        total_size = 0;
                    }
                }
                else {
                    total_size = 0;
                }
                // calculate total pages
                let total_page_count = Math.ceil(total_size / page_size);

                let start_page_number=1, end_page_number=1;
                if (total_page_count <= 10) {
                    // less than 10 total pages so show all
                    start_page_number = 1;
                    end_page_number = total_page_count;
                } else {
                    // more than 10 total pages so calculate start and end pages
                    if (current_page_number <= 6) {
                        start_page_number = 1;
                        end_page_number = 10;
                    } else if (current_page_number + 4 >= total_page_count) {
                        start_page_number = total_page_count - 9;
                        end_page_number = total_page_count;
                    } else {
                        start_page_number = current_page_number - 5;
                        end_page_number = current_page_number + 4;
                    }
                }
                // calculate start and end item indexes
                let start_index = (current_page_number - 1) * page_size;
                var tMin = start_index + page_size - 1;
                let end_index = Math.min(tMin, total_size - 1);

                let page_array = Array.from(Array(end_page_number + 1 - start_page_number), (_, i) => start_page_number + i);
                // return object with all pager properties required by the view
                return {
                    total_size: total_size,
                    current_page_number: current_page_number,
                    page_size: page_size,
                    total_page_count: total_page_count,
                    start_page_number: start_page_number,
                    end_page_number: end_page_number,
                    start_index: start_index,
                    end_index: end_index,
                    page_array: page_array
                };
            }
        }
    }</script>